<div class="hero-menu" [class.collapsed]="collapse">
  <div class="hero-menu__header">
    <div class="hero-menu__logo">
      <img src="assets/hero/images/logo-hero-small.svg" alt="HERO" class="hero-logo-small" />
      <img src="assets/hero/images/logo-hero.svg" alt="HERO" class="hero-logo" />
      <div class="vr"></div>
      <img src="assets/client/images/logo-client.svg" alt="Client" class="client-logo" />
    </div>
  </div>

  <div class="hero-menu__toogle" (click)="toggleCollapse()">
    <img class="img-toogle img-toogle-open" src="assets/hero/images/menu-open.svg" alt="" >
    <img class="img-toogle img-toogle-close" src="assets/hero/images/menu-close.svg" alt="" >
  </div>

  <div class="hero-menu__apps">
    <div class="hero-menu__app" *ngFor="let app of applications | menuApplication : 'tools'">
      <a
        [routerLink]="app['route']"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <i *ngIf="app['icon']" class="label-icon" [ngClass]="app['icon']"></i>
        <span class="label-name">{{app['name']}}</span>
      </a>
    </div>
  </div>
  <hr>
  <div class="hero-menu__profile">
    <host-profile></host-profile>
  </div>
  <div class="hero-menu__extras">

    <div class="hero-menu__extra">
<!--      <host-notification></host-notification>-->
    </div>
    <div class="hero-menu__extra">
      <a href="https://support.flyingspoon.de" target="_blank" rel="noopener noreferrer">
        <i class="label-icon hero-icon-help"></i>
        <span class="label-name" dictionary="help">Hilfe/FAQ</span>
      </a>
    </div>
    <!-- <div class="hero-menu__extra">
        <a>
            <i class="label-icon hero-icon-settings"></i>
            <span class="label-name" dictionary="settings"></span>
        </a>
    </div> -->
  </div>
  <hr>
  <div class="hero-menu__logout">
    <button class="btn btn-hero btn-hero-primary" (click)="logout()" type="button" [disabled]="disableLogout || disableRenew">
      <i class="hero-icon-power"></i>
      <span class="label-name" dictionary="logout">Abmelden {{sessionCountdown ? sessionCountdown : '' }}</span>
    </button>
    <button *ngIf="expireSoon" class="btn btn-hero btn-hero-primary" (click)="renew()" type="button" [disabled]="disableLogout || disableRenew">
      <i class="fa fa-refresh"></i>
      <span class="label-name" dictionary="renew"></span>
    </button>
  </div>
</div>
